import React, { Component } from "react";
import { Card, Button, Form, Alert, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Redirect, NavLink } from 'react-router-dom'
import AddDepartment from './DepartmentAdd'
import EditDepartmentModal from './EditDepartmentModal'
import axios from 'axios'
import MaterialTable from 'material-table'
import { ThemeProvider } from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles'
import AlertModal from './AlertModal'
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from "./Toaster/CommonToast";
import { hasPermission } from "../utils/usePermission";

export default class DepartmentList extends Component {

	constructor(props) {
		super(props)

		this.state = {
			departments: [],
			jobs: [],
			selectedDepartment: null,
			hasError: false,
			errorMsg: '',
			completed: false,
			showEditModel: false,
			showAlertModel: false,
			loading: false,
			errors: {},
			showToast: true,
			toastMessage: '',
			toastVariant: '',
			color: ''
		}
	}

	componentDidMount() {
		this.setState({ loading: true });
		axios({
			method: 'get',
			url: '/departments',
			headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
		})
			.then(res => {
				this.setState({ departments: res.data, })
				setTimeout(() => {
					this.setState({ loading: false });
				}, 900);
			})
	}

	onEdit(department) {
		return event => {
			event.preventDefault()
			this.setState({ selectedDepartment: department, showEditModel: true })
			setTimeout(() => {
				this.setState({ loading: false });
			}, 900);
		}
	}

	onDelete(department) {
		return event => {
			event.preventDefault()
			this.setState({ loading: true })
			if (department.users.length > 0) {
				this.setState({ showAlertModel: true })
			} else {
				axios({
					method: 'delete',
					url: '/departments/' + department.id,
					headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
				})
					.then(res => {
						this.setState({
							completed: true,
							toastMessage: "Department deleted successfully!",
							toastVariant: 'success',
							color: 'green',
							showToast: true,
						})
						setTimeout(() => {
							this.setState({ showToast: false, loading: false });
						}, 4000);
					})
					.catch(err => {
						this.setState({ hasError: true, errorMsg: err.response.data.message })
						setTimeout(() => {
							this.setState({ showToast: false, loading: false });
						}, 1000);
					})

			}

		}
	}

	render() {
		let closeEditModel = () => this.setState({ showEditModel: false })
		let closeAlertModel = () => this.setState({ showAlertModel: false })

		const theme = createTheme({
			overrides: {
				MuiTableCell: {
					root: {
						padding: '6px 6px 6px 6px'
					}
				}
			}
		})

		return (
			<>
				{this.state.showToast && this.state.toastMessage && (
					<CommonToast
						show={this.state.showToast}
						onClose={() => this.setState({ showToast: false })}
						message={this.state.toastMessage}
						variant={this.state.toastVariant}
						color={this.state.color}
					/>
				)}

				<CommonLoader isLoading={this.state.loading}>
					<div className="container-fluid pt-4">
						<div className="row">
							<div className="col-sm-12">
								<AddDepartment />
							</div>
						</div>
						<div className="row">
							<div className="col-sm-12">
								<Card className="main-card">
									<Card.Header>
										<div className="panel-title">
											<strong>Department List</strong>
										</div>
									</Card.Header>
									<Card.Body>
										<ThemeProvider theme={theme}>
											<MaterialTable
												columns={[
													{
														title: 'DEPT ID', field: 'id',
														cellStyle: { minWidth: 200, textAlign: 'center' },
														headerStyle: { minWidth: 200, textAlign: 'center' }
													},
													{
														title: 'Department Name', field: 'departmentName',
														cellStyle: { minWidth: 200, textAlign: 'center' },
														headerStyle: { minWidth: 200, textAlign: 'center' }
													},
													{
														title: 'Jobs',
														cellStyle: { minWidth: 200, textAlign: 'center' },
														headerStyle: { minWidth: 200, textAlign: 'center' },
														render: dept => (
															hasPermission('M3B4') ? (
																<NavLink
																	to={{
																		pathname: '/job-list',
																		state: { selectedDepartment: dept.id }
																	}}
																	className="btn btn-primary btn-sm"
																>
																	<i className="fas fa-briefcase mr-1"></i>Go to Job List
																</NavLink>
															) : null
														)
													},
													{
														title: 'Action',
														render: rowData => (
															<Form className="row justify-content-center">
																<div className="col-auto address-div">
																	{hasPermission('M3B2') && (
																		<OverlayTrigger
																			placement="top"
																			overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Edit Department</Tooltip>}
																		>
																			<Button size="sm" className="info" variant="outline-info" onClick={this.onEdit(rowData)}>
																				<i className="fas fa-edit"></i>
																			</Button>
																		</OverlayTrigger>
																	)}
																	{hasPermission('M3B3') && (
																		<OverlayTrigger
																			placement="top"
																			overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Delete Department</Tooltip>}
																		>
																			<Button size="sm" variant="outline-danger"
																				className="delete-btn" onClick={this.onDelete(rowData)}>
																				<i className="fas fa-trash"></i>
																			</Button>
																		</OverlayTrigger>
																	)}
																</div>
															</Form>
														),
														cellStyle: { width: '250px', minWidth: '250px', textAlign: 'center' },
														headerStyle: { width: '250px', minWidth: '250px', textAlign: 'center' }
													}
												]}
												data={this.state.departments}

												options={{
													rowStyle: (rowData, index) => {
														if (index % 2) {
															return { backgroundColor: '#f2f2f2' }
														}
													},
													pageSize: 8,
													pageSizeOptions: [5, 10, 20, 30, 50, 75, 100]
												}}
												title="Departments"
											/>
										</ThemeProvider>
									</Card.Body>
								</Card>
								{this.state.showEditModel ? (
									<EditDepartmentModal show={true} onHide={closeEditModel} data={this.state.selectedDepartment} />
								) : this.state.showAlertModel ? (
									<AlertModal show={true} onHide={closeAlertModel} />
								) : (<></>)}
							</div>
						</div>
						{this.state.hasError ? (
							<Alert variant="outline-danger" className="m-3" block>
								{this.state.errMsg}
							</Alert>
						) : this.state.completed ? (
							<Redirect to="/departments" />
						) : (<></>)}
					</div>
				</CommonLoader >
			</>
		);
	}
}